import { useRef, useState } from 'react';
import {
  Badge,
  ButtonIcon,
  IconNotification,
  Popover,
  Box,
  Label,
  Button,
  Text,
  useDetectDevice,
} from '@acv/clearcar-component-lib';
import { useLocale } from '@portal/hooks';
import { Notification as NotificationList } from '@portal/notifications';
import { boxProp } from '@portal/notifications/lib';
import { useRouter } from 'next/router';
import { Route } from '@portal/lib';

const RenderNoNotifications = ({ boxProp, message }) => {
  return <Box {...boxProp}>{message}</Box>;
};

const NotificationPopover = ({ notificationCount, notifications }) => {
  const popoverTargetRef = useRef(null);
  const { locale } = useLocale();
  const router = useRouter();
  const { isMobile } = useDetectDevice();

  const [isNotificationOpen, setIsNotificationOpen] = useState(false);

  const openNotificationPage = () => {
    router.push(Route.notificationListPage.path);
  };

  const emptyNotifications = notifications?.length === 0;
  return (
    <Box data-testid="e2e-notification-container">
      <ButtonIcon
        forwardedRef={popoverTargetRef}
        onClick={() => setIsNotificationOpen(true)}
        data-testid="e2e-notification-button"
      >
        <Badge
          notificationCount={notificationCount}
          color="error"
          verticalAlignment="bottom"
          horizontalAlignment="right"
          data-testid="e2e-notification-badge"
        >
          <IconNotification height="24" width="24" data-testid="e2e-notification-icon" />
        </Badge>
      </ButtonIcon>
      <Popover
        // isHorizontal={false}
        isOpen={isNotificationOpen}
        onClose={() => setIsNotificationOpen(false)}
        target={popoverTargetRef.current}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        transformOrigin={{
          horizontal: 'left',
          vertical: 'top',
        }}
        PaperProps={{
          style: {
            width: isMobile ? '90vw' : '25vw',
            ...(isMobile && { left: '100px' }),
            ...(isMobile && { left: '47px' }),
          },
        }}
        marginTop="md"
        data-testid="e2e-notification-popover"
      >
        <Box direction="column" flexGap="md" align="flex-start" padding="lg" data-testid="e2e-notification-content">
          <Box isFlex justify="space-between" width="full" data-testid="e2e-notification-header">
            <Label weight="bold" color="gray-text" data-testid="e2e-notification-title">
              {locale.notifications}
            </Label>
            {!emptyNotifications && (
              <Button
                isRounded
                isCapitalCase
                size="xs"
                onClick={openNotificationPage}
                data-testid="e2e-see-all-notifications-button"
              >
                <Text color="light" data-testid="e2e-see-all-notifications-text">{locale.seeAllNotifications}</Text>
              </Button>
            )}
          </Box>
          {!!emptyNotifications ? (
            <RenderNoNotifications
              boxProp={boxProp}
              message={locale.noNotifications}
              data-testid="e2e-no-notifications"
            />
          ) : (
            <NotificationList
              data={notifications}
              showPagination={false}
              showPanelNotification
              data-testid="e2e-notification-list"
            />
          )}
        </Box>
      </Popover>
    </Box>
  );
};

export default NotificationPopover;
